<div class="suif-panel">
    <div class="error-box-header">
        <div class="error-header-title">Page Not Found</div>
    </div>

    <div class="error-box-body">
        <div class="error-container">
            <img src="/images/sad-cloud.svg" alt="">
            <p>The page you were looking for does not exist.</p>
        </div>

        <div class="button-row">
            <button type="button" class="btn btn-primary" (click)="submit()">{{submitLabel}}</button>
        </div>
    </div>

</div>
